const API_URL = "https://app.tavad.com/hce/wp-json";

export async function reset(email) {
  const resetMail = {
    email
  };
  try {
    const response = await fetch(`${API_URL}/bdpwr/v1/reset-password`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(resetMail),
    } );
    const data = await response.json();

    console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
}